<template>
  <v-main v-if="user" class="app-layout">
    <app-navigation
      :drawer="drawer"
      @update:drawer="drawer = $event"
    ></app-navigation>
    <app-toolbar ref="appToolbar" @set-drawer="drawer = !drawer"></app-toolbar>
    <v-fade-transition mode="out-in">
      <router-view ref="view" @show-hotel-selector="showHotelSelector">
      </router-view>
    </v-fade-transition>
  </v-main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { axiosGet } from "@/api/requests";
import handleErrorStatus from "@/mixins/handleErrorStatus";
import snackBarMessages from "@/mixins/snackBarMessages";
import AppToolbar from "@/components/globals/AppToolbar";
import AppNavigation from "@/components/globals/AppNavigation";

import { getHotelStoreObject } from "@/helpers/objectHelpers";

export default {
  components: {
    AppToolbar,
    AppNavigation,
  },
  mixins: [snackBarMessages, handleErrorStatus],
  data: () => ({
    drawer: false,
  }),
  computed: {
    ...mapState(["user", "currentHotel", "connection"]),
  },
  created() {
    if (!this.currentHotel) {
      const hotels = this.user.hotels.trim().split(";");
      if (
        this.user.cloudData.length >= 1 &&
        hotels.length === 1 &&
        hotels[0] !== ""
      ) {
        this.$nextTick(() => {
          this.getHotel(hotels[0]);
        });
      }
    }
  },
  methods: {
    getHotel(code) {
      this.$root.$loader.open(this.$t("loadingHotel"));
      const url =
        process.env.VUE_APP_DATA_URL +
        "/hotel?" +
        "name=" +
        this.connection.code +
        "&hotelcode=" +
        code;
      axiosGet(url, this.user.authToken)
        .then((response) => {
          this.handleGetHotelResponse(response);
        })
        .catch((error) => {
          this.snackbarError(this.$t("loadingHotelFailed"));
        })
        .finally(() => {
          this.$root.$loader.close();
        });
    },
    handleGetHotelResponse(response) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.success) {
        const hotelDetails = getHotelStoreObject(response.hotel);
        this.selectHotel(hotelDetails);
      } else {
        this.snackbarError(this.$t("loadingHotelFailed"));
      }
    },
    showHotelSelector() {
      this.$refs.appToolbar.showDialog("hotelSelector");
    },
    ...mapActions(["selectHotel"]),
  },
};
</script>
